var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg401(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 400,
    viewBox: "0 0 250 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.349 142.511C210.735 141.611 209.701 141.036 208.513 141.036H144.379V121.395H140.891V115.973L190.424 10.4879H163.579L127.497 88.0733L124.355 81.6541L89.4807 10.4879H62.6353L111.114 109.094L112.609 112.14L114.046 115.053V121.395H110.558V141.036H46.4245C44.4892 141.036 42.9371 142.607 42.9371 144.543V385.596C42.9371 386.86 43.6078 387.991 44.6234 388.585C45.1407 388.91 45.7539 389.102 46.4245 389.102H208.513C210.448 389.102 212 387.531 212 385.596V144.543C212 143.795 211.77 143.086 211.349 142.511ZM122.937 134.828C122.937 132.317 124.949 130.305 127.459 130.305H127.516C129.988 130.344 131.981 132.337 131.981 134.828C131.981 137.319 129.95 139.35 127.459 139.35C125.179 139.35 123.32 137.683 122.994 135.517C122.956 135.307 122.937 135.058 122.937 134.828ZM150.012 157.553C150.012 159.661 148.288 161.386 146.161 161.386H108.776C106.649 161.386 104.925 159.661 104.925 157.553V153.932C104.925 151.824 106.649 150.08 108.776 150.08H110.558V155.733H144.379V150.08H146.161C148.288 150.08 150.012 151.824 150.012 153.932V157.553Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.941 138.679C206.328 137.779 205.293 137.204 204.105 137.204H42.0174C40.0821 137.204 38.53 138.775 38.53 140.71V381.763C38.53 383.028 39.2006 384.158 40.2162 384.752C40.7336 385.078 41.3467 385.27 42.0174 385.27H204.105C206.041 385.27 207.593 383.699 207.593 381.763V140.71C207.593 139.963 207.363 139.254 206.941 138.679ZM145.605 153.721C145.605 155.829 143.88 157.572 141.754 157.572H104.35C102.242 157.572 100.499 155.848 100.499 153.721V150.099C100.499 147.992 102.223 146.248 104.35 146.248H141.754C143.861 146.248 145.605 147.972 145.605 150.099V153.721Z",
    fill: "url(#paint0_linear_2055_40663)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.492 202.104H58.6305V347.445H187.492V202.104Z",
    fill: "#F0F5F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.151 117.563V151.901H139.972V117.563H106.151ZM123.052 135.498C120.561 135.498 118.53 133.467 118.53 130.976C118.53 128.485 120.561 126.454 123.052 126.454C125.543 126.454 127.574 128.485 127.574 130.976C127.574 133.467 125.543 135.498 123.052 135.498Z",
    fill: "#043E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.492 323.071H58.6305V372.815H187.492V323.071Z",
    fill: "#3FA9F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.342 180.202C100.882 179.915 100.384 179.685 99.8663 179.512C99.3298 179.34 98.7933 179.187 98.2376 179.091C97.6819 178.995 97.2029 178.861 96.7621 178.765C96.3214 178.669 95.9573 178.516 95.6699 178.344C95.3825 178.171 95.2484 177.941 95.2484 177.615C95.2484 177.405 95.325 177.213 95.4591 177.041C95.5933 176.868 95.8232 176.715 96.149 176.6C96.4747 176.485 96.8963 176.427 97.4136 176.427C98.0076 176.427 98.6017 176.504 99.234 176.677C99.8663 176.849 100.499 177.098 101.131 177.462L102.281 174.665C101.629 174.262 100.882 173.975 100.039 173.764C99.1957 173.572 98.3142 173.477 97.452 173.477C96.1298 173.477 95.0376 173.668 94.1562 174.071C93.2747 174.473 92.6232 174.99 92.1825 175.642C91.7418 176.293 91.531 177.021 91.531 177.807C91.531 178.516 91.6651 179.11 91.9526 179.589C92.2208 180.068 92.5849 180.451 93.0256 180.739C93.4663 181.026 93.9645 181.275 94.5202 181.448C95.0759 181.62 95.6124 181.773 96.149 181.888C96.6855 182.003 97.1645 182.118 97.6244 182.233C98.0843 182.348 98.4484 182.502 98.7166 182.674C98.9849 182.847 99.1382 183.076 99.1382 183.364C99.1382 183.594 99.0615 183.785 98.9082 183.958C98.7549 184.13 98.525 184.245 98.2184 184.341C97.9118 184.437 97.4903 184.475 96.9346 184.475C96.149 184.475 95.3825 184.36 94.5777 184.111C93.7921 183.862 93.1023 183.556 92.5083 183.153L91.2628 185.97C91.8951 186.391 92.6999 186.736 93.7346 187.005C94.7502 187.273 95.8041 187.407 96.9346 187.407C98.2567 187.407 99.3681 187.215 100.25 186.813C101.131 186.411 101.782 185.893 102.223 185.223C102.664 184.571 102.894 183.843 102.894 183.076C102.894 182.368 102.76 181.793 102.472 181.314C102.185 180.854 101.821 180.471 101.38 180.183L101.342 180.202Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.406 173.745H103.392V176.753H107.512V187.158H111.306V176.753H115.406V173.745Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.733 173.745L114.812 187.158H118.683L119.737 184.533H125.409L126.463 187.158H130.41L124.47 173.745H120.733ZM120.848 181.754L122.573 177.462L124.297 181.754H120.848Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.77 187.158H135.564V182.559H141.466V179.627H135.564V176.696H142.271V173.745H131.77V187.158Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M154.841 176.696V173.745H144.34V187.158H148.134V182.559H154.036V179.627H148.134V176.696H154.841Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1993 351.45H70.9323V362.717H82.1993V351.45Z",
    fill: "#F0F5F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.19 351.45H87.8327V362.717H175.19V351.45Z",
    fill: "#F0F5F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1993 334.549H70.9323V345.816H82.1993V334.549Z",
    fill: "#F0F5F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.19 334.549H87.8327V345.816H175.19V334.549Z",
    fill: "#F0F5F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.538 10.4879L136.484 112.14H109.639L111.114 109.094L123.109 84.2409L124.355 81.6541L158.692 10.4879H185.538Z",
    fill: "url(#paint1_linear_2055_40663)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.109 84.2409L86.5106 10.4879H59.6652L109.639 111.22V131.704C109.639 133.429 109.964 135.077 110.558 136.571C112.494 141.592 117.361 145.137 123.052 145.137C130.467 145.137 136.484 139.12 136.484 131.704V111.22L123.109 84.2409ZM118.53 130.995C118.53 128.485 120.542 126.473 123.052 126.473C125.313 126.473 127.191 128.121 127.516 130.305C127.555 130.535 127.574 130.765 127.574 130.995C127.574 133.486 125.543 135.517 123.052 135.517H122.994C120.503 135.479 118.53 133.467 118.53 130.995Z",
    fill: "url(#paint2_linear_2055_40663)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.757 217.625C111.306 217.625 100.365 228.566 100.365 242.018V253.859H109.16V242.018C109.16 233.414 116.154 226.401 124.757 226.401C133.361 226.401 140.374 233.414 140.374 242.018V253.859H149.15V242.018C149.15 228.566 138.209 217.625 124.757 217.625Z",
    fill: "#B6B6B6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2327 253.859H93.2747V304.235H94.2327V253.859Z",
    fill: "#2AC8FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1908 253.86H94.2327V304.235H95.1908V253.86Z",
    fill: "#28C5FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1489 253.86H95.1908V304.235H96.1489V253.86Z",
    fill: "#27C3FD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0878 253.86H96.1297V304.235H97.0878V253.86Z",
    fill: "#25C0FC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0458 253.86H97.0878V304.235H98.0458V253.86Z",
    fill: "#24BEFB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0039 253.86H98.0459V304.235H99.0039V253.86Z",
    fill: "#22BBFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9429 253.86H98.9848V304.235H99.9429V253.86Z",
    fill: "#21B9F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100.901 253.86H99.9429V304.235H100.901V253.86Z",
    fill: "#1FB7F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.84 253.86H100.882V304.235H101.84V253.86Z",
    fill: "#1EB4F8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.798 253.86H101.84V304.235H102.798V253.86Z",
    fill: "#1CB2F7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.756 253.86H102.798V304.235H103.756V253.86Z",
    fill: "#1BB0F6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.695 253.86H103.737V304.235H104.695V253.86Z",
    fill: "#1AAEF5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M105.653 253.86H104.695V304.235H105.653V253.86Z",
    fill: "#19ACF5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.611 253.86H105.653V304.235H106.611V253.86Z",
    fill: "#17AAF4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.55 253.86H106.592V304.235H107.55V253.86Z",
    fill: "#16A8F3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.508 253.86H107.55V304.235H108.508V253.86Z",
    fill: "#15A7F3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.447 253.86H108.489V304.235H109.447V253.86Z",
    fill: "#14A5F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M110.405 253.86H109.447V304.235H110.405V253.86Z",
    fill: "#13A3F1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M111.363 253.86H110.405V304.235H111.363V253.86Z",
    fill: "#12A2F1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M112.302 253.86H111.344V304.235H112.302V253.86Z",
    fill: "#11A0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 253.86H112.302V304.235H113.26V253.86Z",
    fill: "#109FF0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.199 253.86H113.241V304.235H114.199V253.86Z",
    fill: "#0F9DEF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M115.157 253.86H114.199V304.235H115.157V253.86Z",
    fill: "#0E9CEE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M116.115 253.86H115.157V304.235H116.115V253.86Z",
    fill: "#0D9AEE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M117.054 253.86H116.096V304.235H117.054V253.86Z",
    fill: "#0D99ED"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M118.012 253.86H117.054V304.235H118.012V253.86Z",
    fill: "#0C98ED"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M118.97 253.86H118.012V304.235H118.97V253.86Z",
    fill: "#0B97ED"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M119.909 253.86H118.951V304.235H119.909V253.86Z",
    fill: "#0A95EC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120.867 253.86H119.909V304.235H120.867V253.86Z",
    fill: "#0A94EC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M121.806 253.86H120.848V304.235H121.806V253.86Z",
    fill: "#0993EB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M122.764 253.86H121.806V304.235H122.764V253.86Z",
    fill: "#0892EB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M123.722 253.86H122.764V304.235H123.722V253.86Z",
    fill: "#0891EB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.661 253.86H123.703V304.235H124.661V253.86Z",
    fill: "#0790EA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M125.619 253.86H124.661V304.235H125.619V253.86Z",
    fill: "#0790EA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M126.558 253.86H125.6V304.235H126.558V253.86Z",
    fill: "#068FEA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M127.516 253.86H126.558V304.235H127.516V253.86Z",
    fill: "#068EE9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M128.474 253.86H127.516V304.235H128.474V253.86Z",
    fill: "#058DE9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M129.413 253.86H128.455V304.235H129.413V253.86Z",
    fill: "#058CE9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M130.371 253.86H129.413V304.235H130.371V253.86Z",
    fill: "#048CE9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M131.33 253.86H130.371V304.235H131.33V253.86Z",
    fill: "#048BE8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M132.269 253.86H131.31V304.235H132.269V253.86Z",
    fill: "#038BE8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M133.227 253.86H132.269V304.235H133.227V253.86Z",
    fill: "#038AE8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M134.166 253.86H133.207V304.235H134.166V253.86Z",
    fill: "#0389E8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M135.124 253.86H134.166V304.235H135.124V253.86Z",
    fill: "#0389E7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M136.082 253.86H135.124V304.235H136.082V253.86Z",
    fill: "#0289E7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 253.86H136.063V304.235H137.021V253.86Z",
    fill: "#0288E7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M137.979 253.86H137.021V304.235H137.979V253.86Z",
    fill: "#0288E7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M138.937 253.86H137.979V304.235H138.937V253.86Z",
    fill: "#0287E7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M139.876 253.86H138.918V304.235H139.876V253.86Z",
    fill: "#0187E7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M140.834 253.86H139.876V304.235H140.834V253.86Z",
    fill: "#0187E7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M141.773 253.86H140.815V304.235H141.773V253.86Z",
    fill: "#0187E7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M142.731 253.86H141.773V304.235H142.731V253.86Z",
    fill: "#0186E6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M143.689 253.86H142.731V304.235H143.689V253.86Z",
    fill: "#0186E6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M144.628 253.86H143.67V304.235H144.628V253.86Z",
    fill: "#0186E6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M145.586 253.86H144.628V304.235H145.586V253.86Z",
    fill: "#0086E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M146.525 253.86H145.567V304.235H146.525V253.86Z",
    fill: "#0086E6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M147.483 253.86H146.525V304.235H147.483V253.86Z",
    fill: "#0085E6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M148.441 253.86H147.483V304.235H148.441V253.86Z",
    fill: "#0085E6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M149.38 253.86H148.422V304.235H149.38V253.86Z",
    fill: "#0085E6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M150.338 253.86H149.38V304.235H150.338V253.86Z",
    fill: "#0085E6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M151.296 253.86H150.338V304.235H151.296V253.86Z",
    fill: "#0085E6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M152.235 253.86H151.277V304.235H152.235V253.86Z",
    fill: "#0085E6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M153.193 253.86H152.235V304.235H153.193V253.86Z",
    fill: "#0085E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M154.132 253.86H153.174V304.235H154.132V253.86Z",
    fill: "#0085E6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M155.09 253.86H154.132V304.235H155.09V253.86Z",
    fill: "#0085E6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M156.048 253.86H155.09V304.235H156.048V253.86Z",
    fill: "#0085E6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M156.987 253.86H156.029V304.235H156.987V253.86Z",
    fill: "#0085E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M130.257 275.225C130.257 272.408 127.976 270.108 125.14 270.108C122.304 270.108 120.024 272.389 120.024 275.225C120.024 277.371 121.346 279.191 123.224 279.958V288.005H127.057V279.958C128.934 279.191 130.257 277.371 130.257 275.225Z",
    fill: "#F0F5F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M207.593 140.71V381.763C207.593 383.699 206.041 385.27 204.105 385.27H42.0174C41.3467 385.27 40.7335 385.078 40.2162 384.752L206.941 138.679C207.363 139.254 207.593 139.963 207.593 140.71Z",
    fill: "url(#paint3_radial_2055_40663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2055_40663",
    x1: 19.8091,
    y1: 157.975,
    x2: 226.314,
    y2: 364.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0083E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#007FDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0077CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#016DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#025FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#034E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#043E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2055_40663",
    x1: 97.1261,
    y1: 90.4493,
    x2: 198.05,
    y2: 32.1788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#024574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#015997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#0169B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0075CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#007ED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#0083E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2055_40663",
    x1: 59.6652,
    y1: 77.8026,
    x2: 136.484,
    y2: 77.8026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1FB6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#11A0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0791EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0187E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2055_40663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.914 261.965) scale(105.37 105.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg401);
export default __webpack_public_path__ + "static/media/401.28c5ad68dfae3b0588fe2612a5198b70.svg";
export { ForwardRef as ReactComponent };